import React from 'react';
import t from 'prop-types';

var EntradaTipoBotonLibro = function EntradaTipoBotonLibro(_ref) {
  var titulo = _ref.titulo,
      indice = _ref.indice,
      activa = _ref.activa,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: 'botonLibro ' + indice + (activa ? ' activa' : ''),
    onClick: onClick
  }, titulo && React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  }));
};

EntradaTipoBotonLibro.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  activa: t.bool,
  indice: t.string,
  onClick: t.func
} : {};
export default EntradaTipoBotonLibro;